<script setup lang="ts">
    import { ref } from 'vue';
    import FormCheckable from '@shared/components/Form/FormCheckable.vue';
    import { SwitchStyle } from '@shared/components/Form/Form';

    const updateEnabled = defineModel<boolean>({ required: true });

    const dismissed = ref(false);
</script>

<template>
    <div role="alert" class="alert alert-warning alert-fixed-i" v-show="!dismissed">
        <button type="button" class="close" v-show="updateEnabled" @click="dismissed = true">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">{{ $Resources.CloseBtn }}</span>
        </button>

        <div class="d-flex flex-wrap gap-sm">
            <p class="m-0-b">
                <i class="fa fa-lock" aria-hidden="true" v-show="!updateEnabled"></i>
                <i class="fa fa-unlock-alt" aria-hidden="true" v-show="updateEnabled"></i>
                <strong>{{ $Resources.EventEnableEditingAlertHeading }}</strong>
                {{ $Resources.EventEnableEditingAlertText }}
            </p>

            <FormCheckable
                :checked="updateEnabled"
                :label="$Resources.EventEnableEditingLabelText"
                :switchStyle="SwitchStyle.Standard"
                @update:modelValue="(newVal: unknown) => (updateEnabled = !!newVal)" />
        </div>
    </div>
</template>

<style scoped>
    .alert {
        z-index: 10;
        position: sticky;
        top: var(--ug-spacing-sm);
        outline: 1px solid rgba(0, 0, 0, 0.15);
    }
</style>
